import React from 'react';
import { Container, Grid, Typography, Card, CardContent } from '@mui/material';
import { motion } from 'framer-motion';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import AndroidIcon from '@mui/icons-material/Android';
import DevicesIcon from '@mui/icons-material/Devices';
import WebIcon from '@mui/icons-material/Web';
import BuildIcon from '@mui/icons-material/Build';
import SystemUpdateAltIcon from '@mui/icons-material/SystemUpdateAlt';
import './MobileServices.css';

const services = [
  {
    icon: <PhoneIphoneIcon sx={{ fontSize: 40 }} />,
    title: 'iOS Development',
    description: 'Native iOS applications built with Swift and SwiftUI, delivering seamless experiences on Apple devices.'
  },
  {
    icon: <AndroidIcon sx={{ fontSize: 40 }} />,
    title: 'Android Development',
    description: 'Robust Android apps using Kotlin and Jetpack Compose, ensuring optimal performance and user experience.'
  },
  {
    icon: <DevicesIcon sx={{ fontSize: 40 }} />,
    title: 'Cross-Platform',
    description: 'Cost-effective solutions using React Native and Flutter for consistent experiences across all platforms.'
  },
  {
    icon: <WebIcon sx={{ fontSize: 40 }} />,
    title: 'Progressive Web Apps',
    description: 'Modern PWAs that combine the best of web and mobile apps, offering offline capabilities and fast loading.'
  },
  {
    icon: <BuildIcon sx={{ fontSize: 40 }} />,
    title: 'App Maintenance',
    description: 'Continuous support, updates, and optimization to keep your mobile applications running smoothly.'
  },
  {
    icon: <SystemUpdateAltIcon sx={{ fontSize: 40 }} />,
    title: 'App Modernization',
    description: 'Transform legacy applications into modern, feature-rich mobile experiences with the latest technologies.'
  }
];

const MobileServices = () => {
  return (
    <section className="services-overview">
      <Container maxWidth="lg">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <Typography variant="h2" className="ma-section-title" gutterBottom>
            Our Mobile Development Services
          </Typography>
          <Typography variant="subtitle1" className="ma-section-subtitle" gutterBottom>
            Comprehensive mobile solutions tailored to your needs
          </Typography>
        </motion.div>

        <Grid container spacing={4} className="services-grid">
          {services.map((service, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
              >
                <Card className="ma-service-card">
                  <CardContent>
                    <div className="service-icon">
                      {service.icon}
                    </div>
                    <Typography variant="h6" className="ma-service-title">
                      {service.title}
                    </Typography>
                    <Typography variant="body2" className="service-description">
                      {service.description}
                    </Typography>
                  </CardContent>
                </Card>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </Container>
    </section>
  );
};

export default MobileServices; 